import axios from "axios";
import isFunction from "lodash/isFunction";
import ApiUrls from "../../../api/project/ApiUrls";

/* =========== filter tool =========== */ // 取得事件分類:語意分析的事件分類 + 林獻堂親屬關係的事件分類(把親屬關係當成事件)
export const getEventTypes = async (props, onSuccess, onError) => {
  try {
    // graph: 語意分析的事件分類放在 graph:lxt_setting
    const url = ApiUrls.getEventTypes().replace("{graph}", "lxt_setting");

    // 後端讀取檔案後會轉成固定格式
    const response = await axios.get(url);
    let formatData = [];
    if (Array.isArray(response?.data?.data)) {
      formatData = response.data.data.map((item) => ({
        ...item,
      }));
    }
    if (isFunction(onSuccess)) {
      onSuccess(formatData);
    }
  } catch (err) {
    const customErr = new Error("讀取事件分類失敗");
    if (isFunction(onError)) {
      onError(customErr);
    }
  }
};
